import { useNavigate } from 'react-router-dom';
import { logout } from '../../utils/api';

export default function StartYourMission(props) {
    const routerNavigate = useNavigate();
    const navigate = props.navigate || routerNavigate;

    return (
        <div className="min-h-[100dvh] bg-white flex flex-col font-sans">
            {/* Main Content */}
            <div className="flex flex-col flex-1 px-10 pt-20 pb-40 relative">

                {/* Title from Image 0 */}
                <h1 className="text-[28px] font-bold text-gray-900 text-center leading-tight">
                    Start Your Mission
                </h1>

                {/* Sign Out Button */}
                <button
                    onClick={logout}
                    className="absolute top-5 right-5 text-gray-500 hover:text-red-500 transition-colors"
                    title="Sign Out"
                >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                    </svg>
                </button>

                {/* Spacer pushes button down */}
                <div className="mt-auto">
                    <button
                        onClick={props.onStartClick}
                        className="w-full max-w-[260px] mx-auto block bg-[#00BFA5] hover:bg-[#00a68f] text-white font-medium py-3 px-6 rounded-xl shadow-md transition transform active:scale-95 text-base uppercase tracking-wide"
                    >
                        Start Mission
                    </button>
                </div>
            </div>

            {/* Bottom Navigation matching Image 0 but centered as requested */}
            <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 shadow-[0_-5px_15px_rgba(0,0,0,0.02)] z-50">
                <div className="flex items-center justify-center gap-x-20 py-4 max-w-md mx-auto">

                    {/* Home - Active */}
                    <button
                        onClick={() => navigate('/collectors-home')}
                        className="flex flex-col items-center space-y-1 text-[#00BFA5]"
                    >
                        <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                        </svg>
                        <span className="text-[11px] font-medium">Home</span>
                    </button>

                    {/* Logs */}
                    <button
                        onClick={() => navigate('/logs')}
                        className="flex flex-col items-center space-y-1 text-gray-400"
                    >
                        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <span className="text-[11px] font-medium">Logs</span>
                    </button>
                </div>
            </nav>
        </div>
    );
};
